module.exports = __webpack_public_path__ + "static/media/logo-white-full.fb23728c.png";